import React from 'react';
import styles from './Heading.module.scss';
import cn from 'classnames';

type HeadingScale = 'h1' | 'h2' | 'h3' | 'h4';

export interface HeadingProps {
  size: HeadingScale;
  as?: HeadingScale;
  className?: string;
}

export const Heading: React.FC<HeadingProps> = ({ size, className, as, children }) => {
  const Tag = size;

  return (
    <Tag className={cn(styles['o-heading'], styles[`o-heading__${as ?? size}`], className)}>
      {children}
    </Tag>
  );
};
